export class ProductModel {
    id: string;
    name: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/products/ProductModel.ts